export const FETCH_DEFAULT = 'FETCH_DEFAULT';
export const FETCH_DEFAULT_FULFILLED = 'FETCH_DEFAULT_FULFILLED';
export const FETCH_DEFAULT_REJECTED = 'FETCH_DEFAULT_REJECTED';
